import {
  Backdrop,
  Box,
  CircularProgress,
  Container,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import api from "../../../../Apis";
import FilterSection from "./Components/FilterSection";

const UsageHistory = () => {
  const [cookies] = useCookies(['is_login']);
  const [currentPage, setCurrentPage] = useState(1);
  const [usageHistoryList, setUsageHistoryList] = useState([]);
  const [totalPage, setTotalPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  // Filter states
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [activeStartDate, setActiveStartDate] = useState('');
  const [activeEndDate, setActiveEndDate] = useState('');

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');

      return `${hours}:${minutes} ${day}/${month}/${year}`;
    } catch (error) {
      return dateString;
    }
  };

  const handleFilter = () => {
    setActiveStartDate(startDate);
    setActiveEndDate(endDate);
    setCurrentPage(1);
    fetchData(1, startDate, endDate);
  };

  const handleClearFilter = () => {
    setStartDate('');
    setEndDate('');
    setActiveStartDate('');
    setActiveEndDate('');
    setCurrentPage(1);
    fetchData(1, '', '');
  };

  const fetchData = async (page = currentPage, filterStartDate = activeStartDate, filterEndDate = activeEndDate) => {
    try {
      setIsLoading(true);

      let url = `${api.gpt_assistant_history}?page=${page}&date_start=${filterStartDate}&date_end=${filterEndDate}`;

      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${cookies.is_login}`,
        },
      });
      const data = await res.json();

      if (data?.success) {
        setUsageHistoryList(data?.data || []);
        setTotalPage(data?.total_page || 1);
      } else {
        console.error("API Error:", data?.message);
      }
    } catch (error) {
      console.error("Error fetching usage history:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData(currentPage, activeStartDate, activeEndDate);
  }, [currentPage]);

  return (
    <div>
      <Container
        disableGutters
        maxWidth="sm"
        component="main"
        sx={{ pt: 8, pb: 6 }}
      >
        <Typography
          component="h1"
          variant="h3"
          align="center"
          color="text.primary"
          gutterBottom
        >
          Lịch sử giao dịch
        </Typography>
      </Container>
      <Container maxWidth="xl">

        <FilterSection
          startDate={startDate}
          endDate={endDate}
          onStartDateChange={setStartDate}
          onEndDateChange={setEndDate}
          onFilter={handleFilter}
          onClearFilter={handleClearFilter}
        />

        {totalPage > 1 && (
          <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 3 }}>
            <Pagination
              count={totalPage}
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
              showFirstButton
              showLastButton
            />
          </Box>
        )}

        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow style={{ whiteSpace: "nowrap" }}>
                <TableCell sx={{ width: 50, fontWeight: 600 }}>STT</TableCell>
                <TableCell sx={{ width: 1000, fontWeight: 600 }}>Nội dung</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Thời gian</TableCell>
                <TableCell align="right" sx={{ fontWeight: 600 }}>Số tiền</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell colSpan={4} align="center" sx={{ py: 5 }}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : usageHistoryList.length > 0 ? (
                usageHistoryList.map((item, index) => (
                  <TableRow
                    key={item.id || index}
                    sx={{
                      '&:hover': {
                        backgroundColor: '#fafafa',
                      }
                    }}
                  >
                    <TableCell>
                      {(currentPage - 1) * 20 + index + 1}
                    </TableCell>
                    <TableCell
                      sx={{
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word"
                      }}
                    >
                      {item.content}
                    </TableCell>
                    <TableCell>
                      {formatDateTime(item.created_at)}
                    </TableCell>
                    <TableCell align="right" sx={{ color: "red", fontWeight: 500 }}>
                      - {Number(item.money || 0).toLocaleString()}đ
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} align="center" sx={{ py: 3 }}>
                    Không có dữ liệu
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {totalPage > 1 && (
          <Box sx={{ display: "flex", justifyContent: "flex-end", paddingY: 3 }}>
            <Pagination
              count={totalPage}
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
              showFirstButton
              showLastButton
            />
          </Box>
        )}

      </Container>
    </div>
  );
};

export default UsageHistory;